export const homeMeta ={
    pageTitle:'Data Privacy Services & Cybersecurity Experts | IG-Smart Ltd',
    pageDescription:'Trust IG-Smart Ltd: Experts in data privacy services, cybersecurity, clinical systems safety, ISO 27001 compliance, & innovation. Your security partners.',
    mainTitle: 'Your Partner in Data Privacy and Cybersecurit'

}

/* Insight */ 
export const blogMeta ={
    pageTitle:'Data Privacy & Cyber Blog | IG-Smart Insights',
    pageDescription:'Explore expert insights on data privacy, cybersecurity, & innovation. Stay ahead in legal, tech, & compliance. Join our Data Privacy & Cyber Blog today!',
    mainTitle: 'Data Protection and Cyber Security Insights'
}

export const ourTeamMeta ={
    pageTitle:'Meet Our Expert Management Consultancy Team | IG-Smart Ltd',
    pageDescription:'Get to know our world-class team. Meet the expert Management Consultancy team behind our award-winning cybersecurity, data privacy, and clinical safety solutions.',
    mainTitle: 'Meet the IG-Smart Team'
}

export const ourValueMeta ={
    pageTitle:'Our Values | IG Smart Ltd',
    pageDescription:"Explore IG-Smart Ltd's core values. Learn how we uphold integrity, excellence, and trust in every aspect of our consultancy services.",
    mainTitle: 'Our Core Values'
}

export const ourSdgMeta ={
    pageTitle:'SDGs Impact | IG-Smart Ltd',
    pageDescription:"Discover our commitment to Sustainable Development Goals. Join us in making a positive impact on the world. Learn more about our initiatives today!",
    mainTitle: "IG-Smart Ltd's Sustainable Development Goals"
}

/* Client Story Pages */ 
export const clientStoryMeta ={
    pageTitle:'Client Compliance & Innovation Successes | IG-Smart Ltd',
    pageDescription:"Discover 15+ years of excellence in data privacy, cybersecurity, and compliance. Explore our client success stories, innovation, & business-winning strategies.",
    mainTitle: "Driving Excellence: Real-world Success Stories in Data Privacy, Cybersecurity, and Clinical Safety Solutions"
}

/* Industries Pages */ 
export const academicMeta ={
    pageTitle:'New Academic & Life Science Research | IG Smart Ltd - Data Protection Consultancy & DPO Services',
    pageDescription:"Award Winning Data Protection and GDPR Consultancy, Cyber Security Consultancy, DPO Services, Cyber Essentials Certification, and ISO 27001 Certification Services UK & Global.",
    mainTitle: "Academic and Life Sciences Research"
}

export const aerospaceMeta ={
    pageTitle:'Aerospace & Border Insights | Data Privacy, Cybersecurity',
    pageDescription:"Explore the latest in aerospace and border control industry trends with a focus on data privacy and cybersecurity. Stay informed and secure.",
    mainTitle: "Navigating Secure Skies and Borders"
}

export const cutomerLoyalityMeta ={
    pageTitle:'Customer Loyalty & Rewards | IG Smart Ltd',
    pageDescription:"Boost customer loyalty with IG-Smart's expertise in data privacy, cyber security, and info governance. Contact us for secure, rewarding experiences.",
    mainTitle: "Customer Loyalty and Rewards Safety"
}

export const centralAndLocalMeta ={
    pageTitle:'Central & Local Government | IG Smart Ltd',
    pageDescription:"Enhance government data security with IG-Smart's expertise. Contact us for specialised solutions and seamless operations.",
    mainTitle: "Central and Local Government"
}

export const climateChangeMeta ={
    pageTitle:'Climate Change & Environment | IG Smart Ltd',
    pageDescription:"Explore the synergy of data privacy, cybersecurity, and environment at IG-Smart Ltd. Partner with us for a secure and sustainable future.",
    mainTitle: "Data Privacy, Cyber Security and Climate Change Resilience"
}

export const charityMeta ={
    pageTitle:'Charity & Not-for-profit | IG Smart Ltd',
    pageDescription:"Unlock opportunities and navigate challenges in the non-profit sector with IG-Smart Ltd. Leverage sensitive data for impactful marketing and fundraising.",
    mainTitle: "Unlocking Data Insights"
}

export const financeMeta ={
    pageTitle:'New Finance | IG Smart Ltd - Data Protection Consultancy & DPO Services',
    pageDescription:"Award Winning Data Protection and GDPR Consultancy, Cyber Security Consultancy, DPO Services, Cyber Essentials Certification, and ISO 27001 Certification Services UK & Global.",
    mainTitle: "Financial Services and Fintech"
}

export const healthandSocialMeta ={
    pageTitle:'Healthcare Tech & Data Privacy Insights ﻿ Separator ﻿ IG-Smart Ltd',
    pageDescription:"Explore healthcare tech & data privacy insights, focusing on enabling care with, data privacy, cybersecurity, clinical systems, and medical device safety.",
    mainTitle: "Health and Social Care"
}

export const insuranceAdjustmentMeta ={
    pageTitle:'Insurance and Loss Adjustment | IG Smart Ltd',
    pageDescription:"Enhance data security in insurance and loss adjustment with IG-Smart Ltd. Contact us for expert guidance and secure operations.",
    mainTitle: "Insurance and Loss Adjustment"
}

export const legalMeta ={
    pageTitle:'Legal & Compliance Solutions | IG-Smart Ltd',
    pageDescription:"Elevate data security and compliance in the legal industry with IG-Smart Ltd. Contact us for professional solutions and expert guidance.",
    mainTitle: "Confidentiality and Compliance"
}

export const mergeAquisitionMeta ={
    pageTitle:'Mergers & Acquisitions | Privacy & Security | IG-Smart Ltd',
    pageDescription:"Navigate Mergers & Acquisitions with IG-Smart Ltd. Over 15 years of expertise in data privacy, cybersecurity, & compliance. Ensure success in innovation.",
    mainTitle: "Mergers & Acquisitions"
}

export const PharmaceuticalandPharmacovigilanceMeta ={
    pageTitle:'Pharma & Pharmacovigilance Insights | Privacy, Cybersecurity',
    pageDescription:"Stay informed on Pharma & Pharmacovigilance insights. Explore data privacy, cybersecurity, clinical systems, and medical device safety trends.",
    mainTitle: "Data Integrity and Patient Safety"
}

export const propertyInvestMeta ={
    pageTitle:'Property Investment & Management | IG Smart Ltd',
    pageDescription:"Enhance data security in Property and Investment Management with IG-Smart Ltd. Contact us for expert guidance and trusted operations.",
    mainTitle: "Property and Investment Management"
}

export const retailMeta = {
    pageTitle:'Retail & FMCG | IG Smart Ltd',
    pageDescription:"Elevate data security in Retail and FMCG with IG-Smart Ltd. Contact us for expert guidance and excellence in operations.",
    mainTitle: "Retail and FMCG"
}

export const securityMeta = {
    pageTitle:'Security Services & Solutions| IG Smart Ltd',
    pageDescription:"Award Winning Data Protection and GDPR Consultancy, Cyber Security Consultancy, DPO Services, Cyber Essentials Certification, and ISO 27001 Certification Services UK & Global.",
    mainTitle: "Security Services & Solutions"
}

export const technologyMeta = {
    pageTitle:'Technology | IG Smart Ltd',
    pageDescription:"Enhance data security in the Technology industry with IG-Smart Ltd. Contact us for expert guidance and thriving in the tech world.",
    mainTitle: "Data Security and Compliance"
}


/* Store Pages */
export const cookieMeta = {
    pageTitle:'Cookie Policy Template | IG Smart Ltd',
    pageDescription:"Cookie Policy Template available to purchase and download from multi-award winning data protection and cyber security consultancy firm, IG-Smart Ltd.",
    mainTitle: "Data Security and Compliance"
}

export const cyberSecurityMeta = {
    pageTitle:'Cyber Security Store | IG Smart Ltd',
    pageDescription:"Award-winning data protection, GDPR, cyber security, DPO, Cyber Essentials, and ISO 27001 services. Contact us for expert guidance.",
    mainTitle: "Cyber Security Store "
}

export const dataPrivacyStoreMeta = {
    pageTitle:'Data Privacy Store | IG Smart Ltd',
    pageDescription:"Award-winning data protection, GDPR, cyber security, DPO, Cyber Essentials, and ISO 27001 services. Contact us for expert guidance.",
    mainTitle: "Data Privacy Store "
}

export const ISO_ISMS_StoreMeta = {
    pageTitle:'ISO 27001 ISMS | IG Smart Ltd',
    pageDescription:"Award-winning data protection, GDPR, cyber security, DPO, Cyber Essentials, and ISO 27001 services. Contact us for expert guidance.",
    mainTitle: "ISO 27001 ISMS"
}

export const clinicalSafetyMeta = {
    pageTitle:'Outsourced Clinical Safety Officer Services | IG-Smart Ltd',
    pageDescription:"Enhance patient safety with our outsourced CSO services. Compliance and expertise for healthcare technology. Consult with us now!",
    mainTitle: "Clinical Safety Officer Services and NHS DTAC"
}

export const gdprComplianceMeta = {
    pageTitle:'Ultimate Simplified GDPR Compliance Toolkit | IG-Smart Ltd',
    pageDescription:"Simplify GDPR compliance with our trusted GDPR compliance toolkit, relied upon by industry leaders. Ensure robust data protection and strict legal adherence.",
    mainTitle: "GDPR Compliance"
}

export const iso27001ToolkitMeta = {
    pageTitle:'ISO 27001 Compliance Toolkit | IG-Smart Ltd',
    pageDescription:"Elevate Your ISO 27001 Compliance with Our ISO 27001 Compliance Toolkit. Trusted by Leading Brands. Ensure Data Security and Legal Compliance.",
    mainTitle: "ISO 27001:2022 Toolkit"
}

export const NHSDataMeta = {
    pageTitle:'ISO 27001 Compliance Toolkit | IG-Smart Ltd',
    pageDescription:"Elevate Your ISO 27001 Compliance with Our ISO 27001 Compliance Toolkit. Trusted by Leading Brands. Ensure Data Security and Legal Compliance.",
    mainTitle: "ISO 27001:2022 Toolkit"
}


/* Courses */
export const caldicottGuardionMeta = {
    pageTitle:'Caldicott Guardian Training Course | Expert Privacy Training',
    pageDescription:"Elevate your expertise with IG-Smart Ltd's Caldicott Guardian training course. Master privacy, compliance, and data protection in health & social. Enroll today!",
    mainTitle: "Caldicott Guardian Training"
} 

export const cyberSecurityRiskCourseMeta = {
    pageTitle:'Cyber Risk & Resilience Consultancy | IG-Smart Ltd',
    pageDescription:"Elevate your security with our Cyber Risk & Resilience Consultancy. Expert in cybersecurity risk assessment & resilient solutions. Protect your business today!",
    mainTitle: "Cyber Resilience and Risk Consultancy"
} 

export const dataAssestOwnerMeta = {
    pageTitle:'Data Asset Owner Training | Privacy & Cyber | IG-Smart Ltd',
    pageDescription:"Data Asset Owner Training. Empower data asset owners. Training for responsible data management. Enhance data governance with our courses.",
    mainTitle: "Data Asset Owner Training"
} 

export const dataProtectionOfficerMeta = {
    pageTitle:'Data Protection Officer Training Online Live | IG-Smart Ltd',
    pageDescription:"Join our multi-award-winning firm for interactive online DPO training. Real-time instruction, practical skills, and expert guidance. Begin your journey today!",
    mainTitle: "Data Protection Officer Training Online Live"
} 

export const dpoHealthCareMeta = {
    pageTitle:'Expert Healthcare DPO Training | IG-Smart Ltd',
    pageDescription:"Healthcare DPO Training. Elevate your healthcare DPO expertise with 15+ years of excellence in data protection compliance training.",
    mainTitle: "DPO Training for Health & Social Care"
} 

export const dpoTrainingForPharmaMeta = {
    pageTitle:'Pharma DPO Training | Regulatory Compliance | IG-Smart Ltd',
    pageDescription:"Elevate your expertise with Pharma DPO training. 15+ years of excellence in privacy, cybersecurity, & compliance training. Ensure legal and tech compliance.",
    mainTitle: "Live Online DPO Training"
} 

export const gdprTrainingOnlineMeta = {
    pageTitle:'GDPR Training by IG-Smart: Master Data Compliance',
    pageDescription:"Unlock GDPR expertise with IG-Smart Ltd. Leading GDPR Training for Compliance Success. Join now for expert guidance & certification.",
    mainTitle: "GDPR Training"
} 

export const gdprTrainingNHSMeta = {
    pageTitle:'GDPR NHS Training | NHS GDPR Compliance | IG-Smart Ltd',
    pageDescription:"Comprehensive GDPR NHS Training by IG-Smart Ltd. Ensure Data Compliance in Healthcare. Expert Instructors & Certification for Success!",
    mainTitle: "GDPR | NHS"
} 

export const informationGovernanceTrainingMeta = {
    pageTitle:'Information Governance Training | IG-Smart Ltd',
    pageDescription:"Unlock Compliance Excellence with Information Governance Training. Elevate Skills & Knowledge. Join Our Courses for Success!",
    mainTitle: "Information Governance Training"
} 


/* Services */

// Resources
export const executiveResourceMeta = {
    pageTitle:'Expert C-Suite Executive Search | IG-Search Ltd',
    pageDescription:"C-Suite Executive Search. Discover top-tier CIOs, CISOs, DPOs, and more. Elevate your leadership with subject matter expert recruitment. Contact us now!",
    mainTitle: "Expert C-Suite Executive Search"
} 

// Audit
export const applicationSecurityMeta = {
    pageTitle:'Application Security Audit Services | IG-Smart Ltd',
    pageDescription:"Commission a comprehensive application security audit. Identify vulnerabilities and protect your software. Request your proposal now!",
    mainTitle: "Application Security Audit Services"
}

export const buisnessContinuityMeta = {
    pageTitle:'BCDR Audit Services | Expert Solutions | IG-Smart Ltd',
    pageDescription:"15+ years of expert BCDR Audit Services, data privacy, cybersecurity, & compliance advice. Audit your continuity & recovery with us. Innovate & stay resilient.",
    mainTitle: "BCDR Audit Services"
}

export const cyberSecuityAuditMeta = {
    pageTitle:'Cyber Security Audit Services | IG-Smart Ltd',
    pageDescription:"Ensure your data's safety with our Cyber Security Audit services. 15+ years of expertise in legal, tech, and regulatory compliance. Protect your business today!",
    mainTitle: "Cyber Security Audit Services"
}

export const dataProtectionAuditMeta = {
    pageTitle:'Data Protection Audit Services for Compliance | IG-Smart Ltd',
    pageDescription:"Discover our thorough Data Protection Audit services to ensure compliance. Identify risks and safeguard your data. Schedule a Data Protection Audit now!",
    mainTitle: "Data Protection Audit Services for Compliance"
}

export const dataPrivacyAuditMeta = {
    pageTitle:'Expert C-Suite Executive Search | IG-Search Ltd',
    pageDescription:"C-Suite Executive Search. Discover top-tier CIOs, CISOs, DPOs, and more. Elevate your leadership with subject matter expert recruitment. Contact us now!",
    mainTitle: "Expert C-Suite Executive Search"
}

export const dataPrivacyComplianceAuditMeta = {
    pageTitle:'Data Privacy Compliance Audit | GDPR | IG-Smart Ltd',
    pageDescription:"Achieve GDPR compliance with our thorough data privacy compliance audit. Identify risks, protect sensitive data, and enhance trust. Schedule an audit now!",
    mainTitle: "Data Privacy Compliance Audit"
}

export const gdprAuditMeta = {
    pageTitle:'GDPR Audit Services | GDPR Compliance Check | IG-Smart Ltd',
    pageDescription:"GDPR compliance made easy. Expert GDPR audit services and implementation solutions for businesses. Request your GDPR audit from IG-Smart Ltd today!",
    mainTitle: "GDPR Audit Services | GDPR Compliance Check | IG-Smart Ltd"
}

export const ISO27001AuditMeta = {
    pageTitle:'ISO 27001 Audit Services | Ensure Compliance | IG-Smart Ltd',
    pageDescription:"Expert ISO 27001 audit services to maintain compliance. Protect sensitive information and bolster security. Schedule an external or internal audit now!",
    mainTitle: "ISO 27001 Audit Services"
}

export const ISMSAuditMeta = {
    pageTitle:'ISO 27001 ISMS | IG Smart Ltd',
    pageDescription:"Award-winning data protection, GDPR, cyber security, DPO, Cyber Essentials, and ISO 27001 services. Contact us for expert guidance.",
    mainTitle: "ISO 27001 ISMS"
}

export const itGeneralAuditMeta = {
    pageTitle:'IT General Controls Audit Services | IG-Smart Ltd',
    pageDescription:"Assess and enhance IT general controls. Ensure compliance and security. Request an audit with our experienced team!",
    mainTitle: "IT General Controls Audit Services"
}

export const networkSecurityAuditMeta = {
    pageTitle:'Network Security Audit Services | IG-Smart Ltd',
    pageDescription:"Secure your network infrastructure. Expert audits to identify vulnerabilities and strengthen your defences. Request an audit today!",
    mainTitle: "Network Security Audit Services"
}

export const physicalSecurityAuditMeta = {
    pageTitle:'Robust Physical Security Audits | IG-Smart Ltd',
    pageDescription:"Assess and enhance your defences with our physical security audits. Protect premises, assets, and people. Schedule a physical security audit with us!",
    mainTitle: "Robust Physical Security Audits"
}

export const recordsManagementAuditMeta = {
    pageTitle:'Expert C-Suite Executive Search | IG-Search Ltd',
    pageDescription:"C-Suite Executive Search. Discover top-tier CIOs, CISOs, DPOs, and more. Elevate your leadership with subject matter expert recruitment. Contact us now!",
    mainTitle: "Expert C-Suite Executive Search"
}

